import React from 'react';
import { commonWidgets } from './CommonWidgets';
import { customWidgets } from './CustomWidgets';
import { coreWidgets } from './CoreWidgets';
const ASSISTANT_HUB_SPI_IMPLEMENTOR = '5e9a9fda-5d98-4339-8ebd-d7721e790b67';
import { getTranslations } from '../shared/translations';
import { _internal_initSideEffectEmitterSingleton } from '@wix/agent-platform-bm-sdk';
const widgetRegistry = [...customWidgets.getComponents(), ...commonWidgets.getComponents(), ...coreWidgets.getComponents()];
export const getChatWidgets = function (initialContext, filter, additionalWidgets) {
  if (initialContext === void 0) {
    initialContext = {
      send: () => {
        console.warn('[getChatWidgets()] "sendUserMessage" not passed');
        return Promise.resolve();
      },
      onWidgetAction: () => {
        console.warn('[getChatWidgets()] "onWidgetAction" not passed');
      },
      httpClient: undefined,
      webActions: {},
      locale: 'en'
    };
  }
  if (filter === void 0) {
    filter = {};
  }
  if (additionalWidgets === void 0) {
    additionalWidgets = [];
  }
  const {
    include,
    exclude
  } = filter;
  const filteredWidgets = widgetRegistry.filter(_ref => {
    let [widgetName] = _ref;
    if (include && !include.includes(widgetName)) {
      return false;
    }
    if (exclude && exclude.includes(widgetName)) {
      return false;
    }
    return true;
  });
  const allWidgets = [...filteredWidgets, ...additionalWidgets];
  const context = getChatWidgetsContext(initialContext);
  const resultWidgets = allWidgets.map(_ref2 => {
    let [widgetName, WidgetComponentImpl] = _ref2;
    return {
      widgetName,
      component: props => {
        const data = props.data ?? {};
        const config = props.config ?? {};
        return /*#__PURE__*/React.createElement(WidgetComponentImpl, {
          data: data,
          context: context,
          config: config
        });
      }
    };
  });

  // preserve getChatWidgets call context
  resultWidgets.context = context;
  return resultWidgets;
};
export const getChatWidgetsContext = initialContext => {
  const {
    locale,
    onWidgetAction
  } = initialContext;
  const {
    t
  } = getTranslations(locale ?? 'en');
  const emitter = _internal_initSideEffectEmitterSingleton();
  const emitSideEffect = (eventName, payload) => {
    try {
      emitter.emitEvent({
        appDefinitionId: ASSISTANT_HUB_SPI_IMPLEMENTOR,
        name: eventName,
        payload
      });
    } catch (err) {
      console.error('Failed to emit side effect from "getChatWidgets()"', err);
    }
  };
  const onWidgetActionWithSideEffect = function () {
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }
    onWidgetAction(...params);
    const [widgetName, data] = params;
    const widgetActionSideEffectPayload = {
      widgetName,
      data
    };
    emitSideEffect('widgetAction', widgetActionSideEffectPayload);
  };
  return {
    ...initialContext,
    t,
    emitSideEffect,
    onWidgetAction: onWidgetActionWithSideEffect
  };
};
//# sourceMappingURL=index.js.map